import React from "react";

import ZydusLogo from "../../assets/images/logos/zydus-logo.svg";
import GoodFlipLogo from "../../assets/images/logos/goodflip-care-logo.svg";

const PoweredByLogo: React.FC = () => {
  return (
    <div className="text-center p-4 flex flex-col items-center justify-center gap-2">
      <div className="text-xs text-gray-600 font-thin">
        Copyright © 2026 TatvaCare | All Rights Reserved
      </div>

      <div className="flex flex-row items-center justify-center gap-1.5">
        <div className="text-xs text-gray-600 font-thin">An initiative by</div>
        <img src={ZydusLogo} alt={`An initiative by`} className="w-14 mb-0.5" />
        <div className="w-px h-4 bg-gray-400 mx-1" />
        <div className="text-xs text-gray-600 font-thin">Powered by</div>
        <img src={GoodFlipLogo} alt={`Powered by`} className="w-20 mt-1" />
      </div>
    </div>
  );
};

export default PoweredByLogo;
